import { Grid } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, getPurpurTypography, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { ProductOverview } from './ProductOverview/ProductOverview';

const maxGallerySize = '42rem';
export const DividerGrid = styled.div`
    display: grid;
    grid-template-columns: 100%;

    ${purpurMedia('lg')`
        grid-template-columns: minmax(min(57.75%, ${maxGallerySize}), ${maxGallerySize}) 41.25%;
        justify-content: space-between;
        column-gap: ${getPurpurSpacing('300')};
    `}
`;

export const PageGrid = styled(Grid)`
    display: block;
    padding-top: 1.563rem;
    padding-bottom: ${getPurpurSpacing('250')};
`;

export const Title = styled.h1`
    font-size: ${getPurpurTypography('scale500')};
    margin: 0 0 ${getPurpurSpacing('300')};
    line-height: ${getPurpurTypography('lineHeightDefault')};

    ${purpurMedia('lg')`
        font-size: ${getPurpurTypography('scale700')};
    `};
`;

export const DescriptionSection = styled(ProductOverview)`
    margin-top: 4.5rem;
`;
